// Sign-in / sign-up page — tab toggle, invite-code sign-up, and the 2FA challenge hand-off.
import { $, postJSON } from './kit';

interface SignInResponse {
  twoFactorRedirect?: boolean;
}

// Explicit refs via kit's $ (getElementById) — bare id globals collide with window built-ins
// (e.g. window.name), which silently broke the Sign-up toggle in the pre-TS version.
const tsiBtn = $<HTMLButtonElement>('tsi');
const tsuBtn = $<HTMLButtonElement>('tsu');
const nameEl = $<HTMLInputElement>('name');
const inviteEl = $<HTMLInputElement>('invite');
const emailEl = $<HTMLInputElement>('email');
const pwEl = $<HTMLInputElement>('pw');
const goBtn = $<HTMLButtonElement>('go');
const errEl = $('err');
const authBox = $('auth');
const tfaBox = $('tfa');
const tfaCodeEl = $<HTMLInputElement>('tfacode');
const tfaVerifyBtn = $<HTMLButtonElement>('tfaVerify');

type Mode = 'si' | 'su';
let m: Mode = 'si';

function mode(x: Mode): void {
  m = x;
  const su = x === 'su';
  tsiBtn.classList.toggle('on', !su); // classList.toggle, not className= (keeps the .btn class)
  tsuBtn.classList.toggle('on', su);
  nameEl.style.display = su ? 'block' : 'none';
  inviteEl.style.display = su ? 'block' : 'none';
  goBtn.textContent = su ? 'Create account' : 'Sign in';
  pwEl.autocomplete = su ? 'new-password' : 'current-password';
  errEl.textContent = '';
}

async function go(): Promise<void> {
  errEl.textContent = '';
  const label = goBtn.textContent ?? 'Sign in';
  goBtn.disabled = true;
  goBtn.textContent = '…'; // in-flight: block double-submit
  const path = m === 'si' ? '/api/auth/sign-in/email' : '/api/auth/sign-up/email';
  const body = m === 'si'
    ? { email: emailEl.value, password: pwEl.value }
    : { email: emailEl.value, password: pwEl.value, name: nameEl.value || emailEl.value, inviteCode: inviteEl.value };
  try {
    const j = await postJSON<SignInResponse>(path, body);
    if (j.twoFactorRedirect) { authBox.style.display = 'none'; tfaBox.style.display = 'block'; return; } // MFA challenge
    location.href = '/'; // signed up (force-enroll redirect) or signed in
  } catch (e) {
    errEl.textContent = (e as Error).message;
  } finally {
    goBtn.disabled = false;
    goBtn.textContent = label;
  }
}

async function verify2fa(): Promise<void> {
  errEl.textContent = '';
  try {
    await postJSON('/api/auth/two-factor/verify-totp', { code: tfaCodeEl.value });
    location.href = '/';
  } catch (e) {
    errEl.textContent = (e as Error).message;
  }
}

tsiBtn.addEventListener('click', () => mode('si'));
tsuBtn.addEventListener('click', () => mode('su'));
goBtn.addEventListener('click', go);
tfaVerifyBtn.addEventListener('click', verify2fa);
